'use strict';

var GridToolbarSystemStatusFlightReoptDirective = function GridToolbarSystemStatusFlightReoptDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-system-status-flight-reopt.html'),
    controller: 'GridToolbarSystemStatusFlightReoptController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        scope.onRowSelection(selectedRows);
      });
    }
  };
};
GridToolbarSystemStatusFlightReoptDirective.$inject = [];
module.exports = GridToolbarSystemStatusFlightReoptDirective;